/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbSecteurDto
 */
export interface FcbSecteurDto {
    /**
     * 
     * @type {string}
     * @memberof FcbSecteurDto
     */
    codesecteur?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbSecteurDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSecteurDto
     */
    idsecteurCrea?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbSecteurDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSecteurDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbSecteurDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSecteurDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSecteurDto
     */
    creationUser?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbSecteurDto
     */
    idSecteurGuid?: string | null;
}

/**
 * Check if a given object implements the FcbSecteurDto interface.
 */
export function instanceOfFcbSecteurDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSecteurDtoFromJSON(json: any): FcbSecteurDto {
    return FcbSecteurDtoFromJSONTyped(json, false);
}

export function FcbSecteurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSecteurDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codesecteur': !exists(json, 'codesecteur') ? undefined : json['codesecteur'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'idsecteurCrea': !exists(json, 'idsecteurCrea') ? undefined : json['idsecteurCrea'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'idSecteurGuid': !exists(json, 'idSecteurGuid') ? undefined : json['idSecteurGuid'],
    };
}

export function FcbSecteurDtoToJSON(value?: FcbSecteurDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codesecteur': value.codesecteur,
        'description': value.description,
        'idsecteurCrea': value.idsecteurCrea,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'actif': value.actif,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'creationUser': value.creationUser,
        'idSecteurGuid': value.idSecteurGuid,
    };
}

